import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigFieldComponent } from './config_field.component';
import { AuthGuard, SharedModule } from '../../../shared';
import { ConfigFieldService } from './config_field.service';

const configFieldRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/config/fields',
    component: ConfigFieldComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [
    SharedModule,
    configFieldRouting,
    NgbModule
  ],
  declarations: [
    ConfigFieldComponent
  ],
  providers: [
    ConfigFieldService
  ],
})
export class ConfigFieldModule { }




// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/config_field/config_field.module.ts